<template>
  <div class="product-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">产品与服务</div>
          <div class="title">智慧医疗自助服务系统</div>
          <div class="subtitle"></div>
          <div class="desc">
            还在为这些问题而烦恼吗？
            <br/>
           医院发卡、挂号、缴费、充值、查询、打印等操作很麻烦，就医流程繁琐；
            <br/>
            医疗自助服务系统为您提供完美解决方案！
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container bg-gray">
        <div class="intro-con" style="max-width: 1400px;">
          <div class="content content-about">
            <div class="about-right" style="width:60%;">
              <div class="about-title" style="padding-left:110px;margin-top:-30px;">智慧医疗自助服务系统</div>
              <div class="about-desc" style="margin-left:111px">
                智慧场所管理云平台是以物联网、互联网、大数据为技术支撑的综合性管理平台。平台融合线下智能硬件、线上智能互联多种渠道，以信众和宗教事务为对象，通过支付结算、信息交互、财务管理、数据可视化等多种应用服务支撑，外部对接银行金融、第三方支付、移动端等系统。
                <br/>
                平台可提供混合云环境资源的统一纳管,统一运营,统一运维服务，平台整体了宗教信息化管理的效率和服务水平，扩宽了自身的宣传渠道，减轻了自身的事务压力。
              </div>
            </div>
            <div class="about-left">
              <div class="image-single">
                <img src="../../assets/images/mss/mss-3.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con" style="max-width: 1450px;">
            <div class="title" style="margin-bottom:30px;">项目实施前后对比</div>
            <div class="subtitle" style="width:45%;padding-left:5%;float:left;">
                实施前
            </div>
            <div class="subtitle" style="width:45%;padding-right:5%;float:right;">
                实施后
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/mss/mss-1.png" style="width:45%;float:left;"/>
                <img src="../../assets/images/pay/arrow-right.png" style="width:9%;margin-bottom:140px;" />
                <img src="../../assets/images/mss/mss-2.png" style="width:45%;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">智慧医疗自助服务系统特色</div>
          <div class="content content-box">
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/mss/feature-1.png"/>
                <div class="box-title">平台对接</div>
                <div class="box-desc" style="text-align:center;">
                  将硬件与软件完美结合，使自助机器能够更符合人们的思维习惯。通过与医院、银行以及第三方的各平台进行无缝对接，让自助机器更加智能、便捷、安全、高效。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/mss/feature-3.png"/>
                <div class="box-title">简化流程</div>
                <div class="box-desc">
                 医疗自助服务，简化了流程，引导式操作，用信息化手段引导老百姓能快速理解与熟悉和操作使用，实现自助挂号、自助预约、自助结算、自助缴纳预交款、自助查询、自助打印、导引等功能。
                </div>
              </div>
            </div>
             <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/mss/feature-2.png"/>
                <div class="box-title">功能齐全</div>
                <div class="box-desc">
                  为人们提供诸如：发卡、挂号、缴费、充值、查询、打印等等功能，从而将就医环境变得更加合谐，就医流程更快速！有序！舒适！
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/mss/feature-4.png"/>
                <div class="box-title">建设目标</div>
                <div class="box-desc">
                禾悦医疗自助服务系统的建设以三方多赢为目标，要让患者、医院、银行全部受益。提高医院医疗管理的信息化水平，提升医院的市场竞争力。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .nav-container {
    width: @width-max;
    margin: 0 auto;
    padding: 26px 0;
    display: flex;
    align-items: center;
    .nava {
      padding: 15px;
      font-size: 16px;
      flex: 1;
      text-align: center;
    }
  }
  .intro-container .intro-con .content.content-box .box-con .box-item {
      height: 290px;
  }
  .box-desc {
      text-align: center;
  }
  .intro-container .intro-con {

  }
</style>



// WEBPACK FOOTER //
// src/pages/product/product5.vue